import React from 'react';
import VideoRoom from './VideoRoom';
import ComponentWrapper from "../../../common/components/ComponentWrapper";

function AdminMeeting() {
  return (
    <div>
      <ComponentWrapper active={2} >
        <h1>Video Room Test</h1>
        <VideoRoom />
      </ComponentWrapper>
    </div>
  );
}

export default AdminMeeting;